module.exports = "+-+-+-+-+-+\n|   |     |\n+-+ + +-+ +\n|     |   |\n+ +-+-+ +-+\n| |     | |\n+ + +-+-+ +\n| | |     |\n+ + + + --+\n| |   |    \n+-+-+-+-+-+"